import React, { useState, useEffect, useCallback } from 'react';
import useForm from '@utils/useForm';
import { styled } from '@linaria/react';
import { css } from '@linaria/core';
import { useTheme, ITheme } from 'src/theme';
import { useAvivaSelector, useAvivaDispatch } from '@redux/hook';
import { setLoadingState, setIsGlobalError } from '@redux/slices/loadingSlice';
import { isEmpty, isNil, get } from 'lodash';
import { useHistory } from "react-router-dom";
import { Helpers } from '@utils/helpers';
import { GAAviva } from '@utils/gaAviva';
import { MyInfoForm, MyInfoAddressForm, AddMyInfoForm } from '@models/MLTC/MyInfo.model';
import { AgentPersonalDetailResponse } from '@models/AgentPersonalDetailRequest.model';
import { QASPostalCodeRequest, QASPostalCodeResponse } from '@models/QASPostalCodeRequest';
import { MyInfoPersonResponse, AddMyInfoRequest } from '@models/MyInfoRequest.model';
import { updateIncome } from '@redux/slices/MLTC/step3Slice';
import { updatePersonalDetails, updateMyInfoAddressForm, updateMyInfoForm, updateL400, updateRetrievedMyInfo, updateHasMyInfo, completeStep, updateMyInfoRawResponse } from '@redux/slices/MLTC/step2Slice';
import { postQASPostalAddress, getAuthoriseURL, getPerson, getRentalProperty, postSavingMyInfo } from '@api/index';


import { LeftGrid, FullGrid, EmptyGrid, ContainerGrid, Container } from '@components/LayoutGrid';
import IconSwap from '@assets/icon/swap.svg';
import SingpassLogo from '@assets/images/singpass-logo.svg';
import Button from '@components/Button';
import MultiSteps from '@components/MultiSteps';
import Heading from '@components/Heading';
import InformationBox from '@components/InformationBox';
import Text from '@components/Text';
import Link from '@components/Link';
import Input from '@components/Input';
import Modal from '@components/Modal';
import Table from '@components/Table';
import Dropdown from '@components/Dropdown';
import Listing from '@components/Listing';
import RadioButtonGroup from '@components/RadioButtonGroup';
import RadioButton from '@components/RadioButton';
import Segment from '@components/Segment';
import TextCollapsible from '@components/TextCollapsible';
import Bullet from '@components/Bullet';
import ContainerBlock from '@components/ContainerBlock';
import Tag from '@components/Tag';
import AddInfoModal from './components/AddMyInfo/AddMyInfo';
import Divider from '@components/Divider';
import Accordion from '@components/Accordion';
import Checkbox from '@components/Checkbox';

import { validate, validateAddress, validateAddMyInfoForm } from './service';
import BulletList from '@components/BulletList';
import { AboutYouForm } from '@models/MLTC/AboutYou.model';
import { UOB_CONTACT_URL } from '@static/config';

const page = 'MyInfo';


const modifyCheckbox = css`
  .checkbox {
    left: 0;
    top: 0;
    transform: unset;
  }
`;

const FlexRow = styled.div`
  display: flex;
  justify-content: space-between;
`

const Box = styled.div<{ theme: ITheme }>`
  padding: 30px
  border: 1px solid ${props => props.theme.colors.grey[700]};
  margin-bottom: 30px;
  @media screen and (min-width: 768px) {
    display: flex;
    padding: 30px;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-items: center;
    .singpass-text {
      margin-right: 30px;
    }
  }
`

const Logo = styled.img`
  width: 146px;
  height: 26px;
  margin-bottom: 12px
`

const PostcodeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  @media screen and (min-width: 768px) {
    flex-direction: row;
    align-items: baseline;
    div {
      width: 100%;
      margin-right: 20px;
    }
    button {
      max-width: 175px;
      white-space: nowrap;
    }
  }
`
const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`

const injectPersonData = {
  "data": {
    "code": 0,
    "id": 0,
    "person": {
      "uinfin": {
        "lastupdated": "-",
        "source": "0",
        "classification": "-",
        "value": "-"
      },
      "name": {
        "lastupdated": "-",
        "source": "0",
        "classification": "-",
        "value": "-"
      },
      "sex": {
        "lastupdated": "-",
        "code": "-",
        "classification": "-",
        "source": "0",
        "desc": "-"
      },
      "race": {
        "lastupdated": "-",
        "code": "-",
        "classification": "-",
        "source": "0",
        "desc": "-"
      },
      "nationality": {
        "code": "-",
        "desc": "-",
        "classification": "-",
        "source": "0",
        "lastupdated": "-"
      },
      "dob": {
        "lastupdated": "-",
        "source": "0",
        "classification": "-",
        "value": "-"
      },
      "email": {
        "lastupdated": "-",
        "source": "0",
        "classification": "-",
        "value": "-"
      },
      "mobileno": {
        "lastupdated": "-",
        "source": "0",
        "classification": "-",
        "areacode": {
          "value": "-"
        },
        "prefix": {
          "value": "-"
        },
        "nbr": {
          "value": "-"
        }
      },
      "regadd": {
        "lastupdated": "-",
        "source": "0",
        "classification": "-",
        "type": "-",
        "country": {
          "code": "-",
          "desc": "-"
        },
        "unit": {
          "value": "-"
        },
        "street": {
          "value": "-"
        },
        "block": {
          "value": "-"
        },
        "postal": {
          "value": "-"
        },
        "floor": {
          "value": "-"
        },
        "building": {
          "value": "-"
        }
      },
      "marital": {
        "code": "-",
        "desc": "-",
        "classification": "-",
        "source": "0",
        "lastupdated": "-"
      },
      "employment": {
        "lastupdated": "-",
        "source": "-",
        "classification": "-",
        "value": ""
      },
      "residentialstatus": {
        "lastupdated": "-",
        "code": "-",
        "classification": "-",
        "source": "0",
        "desc": "-"
      }
    }
  }
}

const mapAddressInfo = (data: any) => {
  return [
    { text: 'Postal code', value: get(data, 'postal', '-') },
    { text: 'Unit', value: get(data, 'floor', '') ? `${get(data, 'floor', '')}-${get(data, 'unit', '-')}` : get(data, 'unit', '-') },
    { text: 'Street', value: get(data, 'street', '-') },
    { text: 'Block', value: get(data, 'block', '-') },
    { text: 'Building name', value: get(data, 'building', '-') },
  ]
}

const trackOnload = (step: string | number = 0): void => {
  const GA = GAAviva.getInstance();
  let { form } = GA.digitalData;
  const formName = Number(step) === 2 ? 'Residential address' : 'Personal details';
  form.name = formName;
  console.log({formName});
  GA.trackPageLoad({ form });
}

const trackFormSubmmit = (error: string = ''): void => {
  const GA = GAAviva.getInstance();
  if (isEmpty(error)) {
    GA.trackFormSuccess({});
    return;
  }
  const { form } = GA.digitalData;
  form.error.messages = error;
  GA.trackFormFailed({ form });
}


export interface MyInfoProps { }

function MyInfo(props: MyInfoProps) {
  console.log(`QnB ➤ PAGE ➤ Aviva - ${page}`);
  const theme: ITheme = useTheme();
  const history = useHistory();

  const startStep: number = 0, endStep: number = 2;
  // const contactInformation = useAvivaSelector(state => state.staticData.contactInformation);
  
  const salutations = useAvivaSelector(state => state.staticData.salutations);
  const nameGuideline = useAvivaSelector(state => state.staticData.namingGuideline);
  const nationlaities = useAvivaSelector(state => state.staticData.nationlaities);
  const races = useAvivaSelector(state => state.staticData.races);
  const maritalStatus = useAvivaSelector(state => state.staticData.maritalStatus);
  const businesses = useAvivaSelector(state => state.staticData.businesses);

  const isStep1Completed = useAvivaSelector(state => state.mltcStep1.isCompleted);
  const promoCode = useAvivaSelector(state => state.mltcStep1.appliedPromoCode);
  // const quoteRawRequest = useAvivaSelector(state => state.mltcStep1.quoteRawRequest)
  const sqsQuotation = useAvivaSelector(state => state.mltcStep1.sqsQuotation);;
  const basicDetails = useAvivaSelector(state => state.mltcStep1.basicDetails);
  const coverages = useAvivaSelector(state => state.mltcStep1.coverage);

  const initValue = useAvivaSelector(state => state.mltcStep2.myInfoForm);
  const initAddressValue = useAvivaSelector(state => state.mltcStep2.myInfoAddressForm);
  const retrievedMyInfo = useAvivaSelector(state => state.mltcStep2.retrievedMyInfo);
  const l400ProfileSlice = useAvivaSelector(state => state.mltcStep2.l400);
  const personRawResponse = useAvivaSelector(state => state.mltcStep2.myInfoRawResponse);
  const isShowAddMyInfo = useAvivaSelector(state => state.loading.isShowAddMyInfo);


  const dispatch = useAvivaDispatch();

  const [isPageLoaded, setIsPageLoaded] = useState<boolean>(false);
  const [personalDetails, setPersonalDetails] = useState<any>(null);
  const [addressInformation, setAddressInformation] = useState<any>(null);
  const [step, setStep] = useState<number>(startStep);
  const [isShowGuideline, setShowGuideline] = useState<boolean>(false);
  const [isDifferenceAddress, setIsDifferenceAddress] = useState<number>(isEmpty(initAddressValue) ? 0 : 1);
  const [isShowSwap, setIsShowSwap] = useState<boolean>(false);
  const [isFoundAddress, setIsFoundAddress] = useState<boolean>(false);
  const [familyName, setFamilyName] = useState<any[]>([]);
  const [givenName, setGivenName] = useState<any[]>([]);
  const [fullName, setFulName] = useState<any[]>([]);
  const [transactionId, setTransactionId] = useState<string>('');
  const [isInjected, setInjected] = useState<boolean>(false);
  const [isGenericError, setIsGenericError] = useState<boolean>(false);
  const [isShowMyInfoPopup, setShowMyInfoPopup] = useState<boolean>(false);
  const [isFindAddressValid, setIsFindAddressValid] = useState<boolean>(true);
  const [myInfoRawResponse, setMyInfoRawResponse] = useState<any>(null);

  const campaignDetail = useAvivaSelector(state => state.loading.campaignDetail);
  const [campaignCode, setCampaignCode] = useState<string>('MLO1');
  const [isShowUOB, setIsShowUOB] = useState<boolean>(false);
  const gotoUOBContact = () => {
    window.open(UOB_CONTACT_URL, "_blank", "noopener noreferrer");
  };

  const urlParams: URLSearchParams = Helpers.getURLSearchParams();
  const paramCC = campaignDetail?.campaignCode ? `?cc=${campaignDetail.campaignCode}` : '';
  const combineParamCC = campaignDetail?.campaignCode ? `&cc=${campaignDetail.campaignCode}` : '';

  const toggleSelectFamilyModal = useCallback(() => { setIsShowSwap(prev => !prev) }, []);

  const toggleSegment = (event: any) => {
    setIsDifferenceAddress(event.target.value);
  }
  const toggleGuideline = () => { setShowGuideline(!isShowGuideline); };

  const onBack = useCallback(() => {
    if (step === endStep) {
      const back = step - 1;
      trackOnload(back);
      history.push(`/mltc/my-info?step=${back}` + combineParamCC);
      setStep(back);
      Helpers.scrollToTop();
    } else {
      history.push('/mltc-r2/choose-plan' + paramCC)
    }
  }, [step, history])

  const {
    handleChange,
    values,
    errors,
    formValid,
    patchValue
  } = useForm(new MyInfoForm(initValue), () => { }, validate);

  const {
    handleChange: changeAddressForm,
    values: addressValues,
    errors: addressErrors,
    formValid: addressFormValid,
    patchValue: patchValueAddressForm
  } = useForm(new MyInfoAddressForm(initAddressValue), () => { }, validateAddress);

  const {
    handleChange: changeAddMyInfo,
    values: addMyInfoValues,
    formValid: addMyInfoFormValid,
    errors: addMyInfoError
  } = useForm(new AddMyInfoForm(null), () => { }, validateAddMyInfoForm);

  const gotoNextStep = useCallback(() => {
    const params = new URLSearchParams(window.location.href.split('?')[1]);
    const inject = params.get('inject');

    const next = step + 1;
    setStep(next);
    trackOnload(next);
    history.push(`/mltc/my-info?step=${next}` + combineParamCC + (inject ? '&inject=true' : ''));
    Helpers.scrollToTop();
  }, [step, setStep, history])

  const onContinue = async () => {
    dispatch(updateMyInfoForm(values));
    dispatch(updatePersonalDetails(personalDetails));
    dispatch(updateMyInfoAddressForm(isDifferenceAddress ? addressValues : null));
    dispatch(updateIncome(new AboutYouForm({ income: values['income'], duties: values['duties'] })));

    const data = myInfoRawResponse;
    const person = new MyInfoPersonResponse(data);
    if (await saveMyInfo(data, person)) {
      if (step < endStep) {
        gotoNextStep();
      } else {
        const params = new URLSearchParams(window.location.href.split('?')[1]);
        const inject = params.get('inject');
        history.push('/mltc-r2/health' + paramCC + (inject ? '?inject=true' : ''));
      }      
    }

  };

  const onFindPlace = async () => {
    const checkLanded = ({ valid, partialAddress, addressLine3 }: { valid: boolean, partialAddress: boolean, addressLine3: string }) => {
      return valid === true && partialAddress === false && isEmpty(addressLine3);
    }
    dispatch(setLoadingState(true));
    const payload = new QASPostalCodeRequest({ postalCode: addressValues['postcode'] });
    try {
      dispatch(setLoadingState(false));
      const response = await postQASPostalAddress(payload);
      const data = get(response, 'data');
      const { valid, partialAddress, addressLine3 } = data;
      setIsFindAddressValid(valid);
      // setIsFindAddressValid(false);
      if (!valid) {
        // if (true) {
        setIsFoundAddress(false);
        patchValueAddressForm(
          {
            block: '',
            unit: '',
            street: '',
            building: '',
          }
        )
      }
      else {
        const address = new QASPostalCodeResponse(data);
        console.debug({ data, address });
        dispatch(setLoadingState(false));
        setIsFoundAddress(true);
        const isLandedProperty = checkLanded({ valid, partialAddress, addressLine3 });
        const unit = get(address, 'addressLine3', undefined);
        patchValueAddressForm(
          {
            block: get(address, 'addressLine1', ''),
            unit: isEmpty(unit) ? undefined : unit,
            street: get(address, 'addressLine2', ''),
            building: get(address, 'addressLine4', ''),
            isLanded: isLandedProperty
          }
        )
      }
      trackFormSubmmit();
    } catch (error) {
      dispatch(setLoadingState(false));
      setIsFindAddressValid(false);
      setIsFoundAddress(false);
      trackFormSubmmit(get(error, 'message'));
      console.error(error);
    }
  }

  const onSwap = useCallback(() => {
    if (isEmpty(fullName)) {
      const full: string[] = values['fullName'].split(' ').map((w: string, idx: number) => ({ w, idx, v: true }));
      values['surname'].split(' ').forEach((e: any) => {
        const refer: any = full.find((o: any) => o.w === e);
        refer.v = false;
      });
      const gName = full.filter((o: any) => o.v === true);
      const fName = full.filter((o: any) => o.v === false);
      setFamilyName(fName);
      setGivenName(gName);
      setFulName(full);
    }

    toggleSelectFamilyModal();
  }, [values, toggleSelectFamilyModal]);

  const onSwapName = useCallback((origin: any) => () => {
    if (givenName.length > 1) {
      const nextFamily = [...familyName, origin];
      const nextGivenName = givenName.filter((o: any) => o.idx !== origin.idx).sort((a, b) => (a.idx - b.idx));
      const nextFullName = fullName.map((o: any) => o.idx === origin.idx ? { ...origin, v: false } : o);

      console.log({ nextFullName, nextFamily, nextGivenName, fullName, givenName });
      setFamilyName(nextFamily);
      setGivenName(nextGivenName);
      setFulName(nextFullName);
    }
  }, [givenName, familyName, fullName]);

  const onClearTagFamimyName = (text: string, index?: number) => {
    if (!isNil(index)) {
      const origin: any = familyName[index];
      const nextValue = familyName.filter((item, i) => i !== index);
      setFamilyName(nextValue);
      // setGivenName([...givenName, { ...origin, v: true }]);
      const nextFullName = fullName.map((o: any) => o.idx === origin.idx ? { ...origin, v: true } : o);
      const gName = nextFullName.filter((o: any) => o.v === true);
      setGivenName(gName);
      // console.log('onClearTagFamilyName', { nextFullName, nextValue, nextGiveName, fullName, givenName, gName });
      setFulName(nextFullName);
    }
  }

  const onConfirmSwap = useCallback(() => {
    console.log(givenName);
    patchValue({
      givname: givenName.map((o: any) => o.w).join(' '),
      surname: familyName.map((o: any) => o.w).join(' ')
    });
    toggleSelectFamilyModal();
  }, [givenName, familyName, patchValue]);

  const onClickRetrieveSingpass = async () => {
    dispatch(updateL400(addMyInfoValues['l400Profile']));
    dispatch(setLoadingState(true));
    try {
      const response = await getAuthoriseURL('mltc');
      const url = get(response, 'data.shortUrl', null);
      console.debug('getAuthoriseURL', url);
      window.open(url, '_self');
    } catch (error) {
      dispatch(setLoadingState(false));
      console.error(error);
    }
  };

  const gotoContact = useCallback((rental: boolean = false) => {
    // check campaign flow
    if (campaignDetail?.code === 'LUB1') {
      setIsShowUOB(true);
    }
    else {
      if (rental) {
        history.push(`/mltc/contact?rental=true` + combineParamCC)
      } else {
        history.push('/mltc-r2/contact' + paramCC)
      }      
    }

  }, [history, campaignDetail]);

  const toggleAddInfoForm = () => {
    setShowMyInfoPopup(!isShowMyInfoPopup);
  }


  const checkBasicDetails = useCallback((retrievedBasicDetails: any) => {
    const savedBasicDetails = basicDetails;
    const savedCoverages = coverages;
    console.debug(`QnB ➤ checkBasicDetails()`, { retrievedBasicDetails, basicDetails, savedCoverages });

    const dob = get(retrievedBasicDetails, 'dob');
    if ((Helpers.parseDobString(savedBasicDetails?.dob) !== dob) && dob !== '0') {
      console.log(`QnB ➤ checkBasicDetails() ➤ DOB compare ➤ `, Helpers.parseDobString(savedBasicDetails), dob);
      history.push('/mltc-r2/basic-details?doberror=true' + combineParamCC);
      return false;
    }
    const gender = get(retrievedBasicDetails, 'gender');
    console.log(`QnB ➤ checkBasicDetails() ➤ Gender compare ➤ `, get(savedBasicDetails, 'gender', 'M'), gender);
    if ((get(savedBasicDetails, 'gender', 'M') !== gender) && (gender !== 'U' && gender !== '')) {
      history.push('/mltc-r2/basic-details?gendererror=true' + combineParamCC);
      return false;
    }
    const nric = get(retrievedBasicDetails, 'nric');
    console.log(`QnB ➤ checkBasicDetails() ➤ NRIC compare ➤ `, { 'not empty': !isEmpty(get(savedCoverages, 'promoNric', '')) }, get(savedCoverages, 'promoNric', ''), nric);
    if (!isEmpty(get(savedCoverages, 'promoNric', '')) && (get(savedCoverages, 'promoNric', '') !== nric)) {
      history.push('/mltc-r2/choose-plan?nricerror=true' + combineParamCC);
      return false;
    }
    return true;
  }, [basicDetails, history]);

  const checkRentalProperty = useCallback(async (postal: string) => {
    try {
      const rentalResponse = await getRentalProperty(postal);
      const rentalProperty = get(rentalResponse, 'data.rentalProperty');
      const bypassRental = urlParams.get('rental');
      console.debug(rentalResponse, rentalProperty, bypassRental);
      if (rentalProperty && bypassRental !== 'true') {
        gotoContact(true);
        return false;
      }
      return true;
    } catch (error) {
      console.error(error);
      return true; //bypass
    }

  }, [urlParams, gotoContact]);


  const saveMyInfo = useCallback(async (data: any, person: MyInfoPersonResponse, customerId: number = 0) => {
    console.debug(`QnB ➤ saveMyInfo(data, person)`, { data, person, addressValues, customerId, retrievedMyInfo });
    const { l400Profile } = addMyInfoValues;
    const id = retrievedMyInfo?.id || customerId;
    const postInfoRequest = new AddMyInfoRequest(null);
    postInfoRequest.patchWithPerson(person);
    postInfoRequest.patchWithValues(values);
    postInfoRequest.l400Profile = l400Profile ? l400Profile : l400ProfileSlice;
    postInfoRequest.isMailingAddressSame = isDifferenceAddress === 1 ? 'N' : 'Y';
    postInfoRequest.annualIncome = values['income'];
    postInfoRequest.exactDutiesOccupation = values['duties'];
    postInfoRequest.businessNature = values['nature'];
    postInfoRequest.businessNatureOthers = values['otherBusiness'] || undefined;
    postInfoRequest.updateMailingAddFlag = values['updateMailing'] ? 'Y' : 'N';

    if (isDifferenceAddress === 1) {
      postInfoRequest.postalCodeMail = addressValues['postcode'];
      postInfoRequest.blockMail = addressValues['block'];
      postInfoRequest.unitMail = addressValues['unit'];
      postInfoRequest.streetNameMail = addressValues['street'];
      postInfoRequest.buildingNameMail = addressValues['building'];
    }

    postInfoRequest.id = id;
    console.log(`QnB ➤ saveMyInfo() ➤ postInfoRequest ➤ `, { postInfoRequest });
    try {
      const savedResponse = await postSavingMyInfo(postInfoRequest);
      const transactionId = get(savedResponse, 'data', 0);
      person.id = transactionId;
      dispatch(updateRetrievedMyInfo(person));
      dispatch(updateHasMyInfo(true));
      return true;
      // trackFormSubmmit();
    } catch (error) {
      // setHasApiError(true);
      dispatch(setIsGlobalError(true));
      console.error(`QnB ➤ saveMyInfo() ➤`, { error });
      return false;
    }
  }, [addMyInfoValues, values, dispatch, isDifferenceAddress, l400ProfileSlice, addressValues, retrievedMyInfo]);

  const loadPerson = useCallback(async (res: any, loadNew: boolean = true) => {
    console.debug(`QnB ➤ loadPerson(res, loadNew) ➤ postInfoRequest ➤ `, { loadNew, res, sqsQuotation });
    dispatch(updateMyInfoRawResponse(res));
    dispatch(setLoadingState(true));

    const data = get(res, 'data.person');
    const customerId = get(res, 'data.id', 0);
    const person = new MyInfoPersonResponse({ id: customerId, ...data });
    if (customerId) {
      person.id = customerId;
    }
    setMyInfoRawResponse(data);

    console.log(`QnB ➤ loadPerson() ➤ data ➤ `, JSON.stringify(data, null, 2));
    console.log(`QnB ➤ loadPerson() ➤ person ➤ `, JSON.stringify(person, null, 2));
    console.log(`QnB ➤ loadPerson() ➤ personalDetails ➤ `, JSON.stringify(person.personalDetails, null, 2));
    const agentInformation = new AgentPersonalDetailResponse(person.personalDetails);
    const address = mapAddressInfo(person.address);
    const myInfoForm = { ...values, ...agentInformation, ...person.address };

    if (loadNew) {
      patchValue(myInfoForm);
    }
    agentInformation.salutation = values['salutation'];
    setPersonalDetails(agentInformation);
    setAddressInformation(address);

    if (
      isEmpty(person.personalDetails.dob) ||
      isEmpty(person.personalDetails.fullName) ||
      isEmpty(person.personalDetails.marital) ||
      isEmpty(person.personalDetails.nationality) ||
      isEmpty(person.address.postal) ||
      isEmpty(person.personalDetails.race)) {
      dispatch(setLoadingState(false));
      if (!isGenericError) {
        setIsGenericError(true);
      }
      return;
    }

    /**
     * 1. Check basic details: dob / gender / nric if have promoNric 
     * 2. Rental property check
     */


    if (!checkBasicDetails(person.personalDetails)) {
      dispatch(setLoadingState(false));
      return;
    }

    if (loadNew) {

      if (!await checkRentalProperty(person.address.postal || '')) {
        dispatch(setLoadingState(false));
        return;
      }
      person.id = customerId;
      dispatch(updateRetrievedMyInfo(person));
      dispatch(updateMyInfoForm(new MyInfoForm(myInfoForm)));
      dispatch(updateMyInfoAddressForm(addressValues));
      dispatch(updatePersonalDetails({ ...agentInformation }));

      dispatch(completeStep(true));
      // console.log('person', { person, customerId });
      if (await saveMyInfo(data, person, customerId)) {
        gotoNextStep();
      }
      // console.log('hasApiError', hasApiError);
    }
    dispatch(setLoadingState(false));
  }, [patchValue, checkBasicDetails, checkRentalProperty, saveMyInfo, gotoNextStep, values, dispatch, addressValues, promoCode])

  const getPersonByTransactionId = useCallback(async (transactionId: string) => {
    try {
      const response = await getPerson(transactionId);
      return response;
    } catch (error) {
      console.error(error);
      return false;
    }
  }, []);

  const handleConsent = useCallback(async () => {
    const transaction_id: string = urlParams.get('transaction_id') || '';
    console.log('QnB ➤ handleConsent() ➤', { transactionId, transaction_id });
    const status = urlParams.get('status');

    if (transactionId === transaction_id) { return; }
    console.debug(transactionId, transaction_id);
    setTransactionId(transaction_id);

    dispatch(setLoadingState(true));

    if (status === 'consent_accepted' && step === 0 && transaction_id) {
      const data = await getPersonByTransactionId(transaction_id);
      if (data) {
        loadPerson(data);
      } else {
        if (!isGenericError) {
          setIsGenericError(true);
        }
        dispatch(setLoadingState(false));
      }
    } else {
      dispatch(setLoadingState(false));
      setIsGenericError(true);
    }
    console.debug(status, transaction_id);
  }, []);

  const loadRetrievedData = useCallback(() => {
    console.log('QnB ➤ loadRetrievedData() ➤');
    if (retrievedMyInfo) {
      const person = new MyInfoPersonResponse(retrievedMyInfo);
      const agentInformation = new AgentPersonalDetailResponse(person.personalDetails);
      const address = mapAddressInfo(person.address);
      setPersonalDetails(agentInformation);
      setAddressInformation(address);
      loadPerson(personRawResponse, false);
    }
  }, [retrievedMyInfo, loadPerson, personRawResponse]);

  useEffect(() => {
    const transaction_id: string = urlParams.get('transaction_id') || '';
    const isInjectPerson = urlParams.get('inject');
    console.log(
      'QnB ➤ useEffect() ➤',
      {
        'step2Slice ➤ initValue': initValue,
        'step2Slice ➤ initAddressValue': initAddressValue,
        campaignDetail,
        isPageLoaded,
        isStep1Completed,
        transaction_id,
        isInjectPerson,
        isInjected,
        sqsQuotation
      }
    );
    if (!isPageLoaded) {
      if (campaignDetail) {
        setCampaignCode(campaignDetail?.code);
      }
      if (!isStep1Completed && process.env.REACT_APP_INJECT_CHECK !== 'true') {
        completeStep(false);
        onBack();
      } else {
        const paramStep = urlParams.get('step');
        trackOnload(paramStep || 0);
        if (paramStep) {
          loadRetrievedData();
          setStep(Number(paramStep));
          setIsPageLoaded(true);
        }
      }
    }

    if (isInjectPerson === 'true' && !isInjected) {
      setInjected(true);
      loadPerson(injectPersonData);
      return;
    } else {
      if (transaction_id) {
        handleConsent();
      }
    }
  }, [setCampaignCode]);


  const addMyInfo = () => {
    const form = new AddMyInfoForm(addMyInfoValues);
    const dataPerson = { data: { person: form.person } };
    patchValue({ salutation: form.salutation });
    loadPerson(dataPerson);
    setShowMyInfoPopup(false);
  }


  return (
    <Container>
      <ContainerGrid>
        <FullGrid>
          <MultiSteps steps={5} step={2} label="Sign up using Myinfo " />
          {step === 0 && (
            <Heading margin="0 0 30px"> Personal details </Heading>
          )}
          {step === 1 && (
            <Heading margin="0 0 30px"> Personal details </Heading>
          )}
          {step === 2 && (
            <Heading margin="0 0 30px"> Residential address </Heading>
          )}
        </FullGrid>
        <LeftGrid>
          {step === 0 && (
            <React.Fragment>
              {isGenericError && (
                <InformationBox variant="error">
                  <Text>We&apos;re unable to retrieve your personal details from MyInfo to proceed with the application.</Text>
                </InformationBox>
              )}
              <Heading variant="sub" fontWeight={600}> Sign up using Myinfo </Heading>
              <Box theme={theme}>
                <Logo src={SingpassLogo} />
                <Text className="singpass-text">Sign in with your Singpass to retrieve your personal details securely. It’ll minimise the number of documents you’ll need to upload to apply for this plan.</Text>
              </Box>
              <InformationBox hasClose margin="0 0 40px">
                <Text>
                  If you’re unable to use Myinfo, please leave your contact details <Link text="here" variant="button" onClick={() => gotoContact(false)} />
                  {campaignCode === 'LUB1' ?
                    ' and a UOB Bancassurance Specialist will contact you shortly.' :
                    ' and our financial adviser representative will be in touch with you shortly.'}
                </Text>
              </InformationBox>

              {(isShowAddMyInfo) && <React.Fragment>
                <Heading margin="0 0 5px" variant="label" >L400 profile*</Heading>
                {!errors?.l400Profile?.isValid && errors?.l400Profile?.message && (<Bullet variant="error">{errors?.l400Profile?.message}</Bullet>)}
                <Input margin="0 0 40px" name="l400Profile" type="alphanumeric" maxLength={10} value={addMyInfoValues["l400Profile"]} onChange={changeAddMyInfo}></Input>
                <Button onClick={toggleAddInfoForm} margin="0 0 20px 0" label="Add MyInfo" />
              </React.Fragment>}
              <Button onClick={onClickRetrieveSingpass} margin="0 0 20px 0" label="Retrieve Myinfo with Singpass" />
              <AddInfoModal
                show={isShowMyInfoPopup}
                onClose={toggleAddInfoForm}
                onChange={changeAddMyInfo}
                valid={addMyInfoFormValid}
                values={addMyInfoValues}
                errors={addMyInfoError}
                salutations={salutations}
                nationlaities={nationlaities}
                races={races}
                maritalStatus={maritalStatus}
                onSubmit={addMyInfo}
              />
            </React.Fragment>
          )}
          {step === 1 && (
            <form onSubmit={e => { e.preventDefault() }} noValidate>
              <InformationBox hasClose>
                <Text> Please ensure that your family name is correct. You will not be able to edit this once you proceed to the next step.</Text>
              </InformationBox>
              <Text fontWeight={600}>Full name (as per NRIC)</Text>
              <Heading fontWeight={300} variant="label" margin="0 0 30px">{`${values['fullName']}`}</Heading>
              <Heading variant="label" disabled margin="0 0 15px">Given name</Heading>
              {values['givname'] && <Input value={values['givname']} disabled readOnly margin="0 0 30px 0" />}
              <FlexRow>
                <Heading variant="label" margin="0 0 10px">Family name</Heading>
                <Link text="Swap" slotIcon="start" variant="button" onClick={onSwap} icon={IconSwap} fontWeight="bold" />
              </FlexRow>
              <Link margin="0 0 15px" text="View customer naming guidelines" fontWeight="bold" variant="button" onClick={toggleGuideline} />
              <Modal show={isShowGuideline} onClose={toggleGuideline}>
                <TableWrapper>
                  <Heading margin="0 0 30px" fontWeight="600" variant="smallTitle">Customer naming guidelines </Heading>
                  <Table source={nameGuideline.source} header={nameGuideline.header} />
                </TableWrapper>
              </Modal>
              <Input value={values['surname']} readOnly margin="0 0 30px 0" />
              <Heading variant="label" margin="0 0 15px">Salutation</Heading>
              <Dropdown source={Helpers.filterSalutations(personalDetails?.gender || '', salutations, personalDetails?.marital || '')} bindLabel="description" name="salutation" bindId="code" value={values['salutation']} onChange={handleChange} placeholder="Please select" />
              <Heading variant="label" margin="0 0 15px">Mobile number</Heading>
              {!errors?.mobileNum?.isValid && errors?.mobileNum?.message && (<Bullet variant="error">{errors?.mobileNum?.message}</Bullet>)}
              <Input variant="prefix" boxLabel="+65" name="mobileNum" invalid={!isEmpty(errors?.mobileNum?.message)} type="numeric" maxLength={8} value={values['mobileNum']} onChange={handleChange}></Input>
              <Heading variant="label" margin="0 0 15px">Email address</Heading>
              {!errors?.emailId?.isValid && errors?.emailId?.message && (<Bullet variant="error">{errors?.emailId?.message}</Bullet>)}
              <Input margin="0 0 30px" name="emailId" value={values['emailId']} invalid={!isEmpty(errors?.emailId?.message)} onChange={handleChange} maxLength={50} />
              <Divider margin="0 0 30px" variant="dashed" />

              <Heading variant="label" margin="0 0 15px">Your job duties</Heading>
              {!errors?.duties?.isValid && errors?.duties?.message && <Bullet variant="error">{errors?.duties?.message}</Bullet>}
              <Input margin="0 0 30px" name="duties" invalid={!isEmpty(errors?.duties?.message)} maxLength={98} value={values['duties']} onChange={handleChange} />
              <Heading variant="label"> Nature of employer&apos;s business </Heading>
              <Dropdown placeholder="Please select" source={businesses} bindId="code" value={values['nature']} bindLabel="description" name="nature" onChange={handleChange} />
              {values['nature'] === '12' && (
                <React.Fragment>
                  <Heading variant="label"> Others </Heading>
                  {!errors?.otherBusiness?.isValid && errors?.otherBusiness?.message && <Bullet variant="error">{errors?.otherBusiness?.message}</Bullet>}
                  <Input margin="0 0 30px" placeholder="Please specify" name="otherBusiness" invalid={!isEmpty(errors?.otherBusiness?.message)} maxLength={98} value={values['otherBusiness']} onChange={handleChange} />
                </React.Fragment>)
              }
              <Heading variant="label"> Your annual income </Heading>
              <Dropdown placeholder="Please select" source={[
                {
                  code: '23999',
                  description: 'Less than $24,000'
                },
                {
                  code: '24001',
                  description: '$24,001 to $36,000'
                },
                {
                  code: '36001',
                  description: '$36,001 to $60,000'
                },
                {
                  code: '60001',
                  description: '$60,001 to $100,000'
                },
                {
                  code: '100001',
                  description: 'More than $100,000'
                },
              ]} bindId="code" value={values['income']} bindLabel="description" name="income" onChange={handleChange} />


              <Divider margin="0 0 20px" size={1} />
              <Accordion
                title="Why do I need to indicate my annual income?"
              >
                <Text margin={'0 0 10px 0'}>
                  You need to indicate your annual income when applying for our long-term care plans because we offer a Guaranteed Issuance Option (GIO), which gives you the flexibility to increase your coverage at key life stage events, without further health underwriting.
                  <br /><br />
                  One of the life stage events is when your salary increases by more than 50% from your application.
                  <br /><br />
                  The other life stage events are:
                </Text>
                <BulletList variant="alphabet" bottomMargin="small">
                  <Bullet>purchases a property;</Bullet>
                  <Bullet>marries, divorces or is widowed;</Bullet>
                  <Bullet>becomes a parent by having a newborn child, or legally adopts a child below 19 ANB;</Bullet>
                  <Bullet>completes a skill development course of at least 6 months;</Bullet>
                  <Bullet>purchases a new Individual Life insurance policy or a Supplementary Benefit from Singapore Life Ltd. with full underwriting at standard terms; or</Bullet>
                  <Bullet>spouse suffers a severe disability (with the inability to perform at least 3 of the 6 ADL) or dies.</Bullet>
                </BulletList>
                <Text>
                  This option allows you to increase the Policy&apos;s monthly benefit with extra premium payable. The total monthly benefit that can be increased under this option is limited to 50% of the Policy&apos;s initial monthly benefit as agreed at policy inception or at the date this option is exercised, whichever is lower. This option is extended to standard life only. Please refer to the Product Summary for more details.
                </Text>
              </Accordion>
              <Divider margin="0 0 20px" size={1} />

              <Button onClick={onContinue} disabled={!formValid} label="Continue" margin="0 0 20px 0" />

              <Modal show={isShowSwap} onClose={toggleSelectFamilyModal}>
                <Heading variant="smallTitle" margin="0 0 30px" fontWeight={600}>Please select your family name/last name</Heading>
                <Heading variant="label"> Family name/last name </Heading>
                {familyName.length === 0 && <Bullet variant="error">This field cannot be empty</Bullet>}
                <Input variant="tag" margin={'0 0 15px 0'} value={familyName.map((o: any) => o.w)} invalid={familyName.length === 0} onClearTag={onClearTagFamimyName} />

                <ContainerBlock>
                  {fullName.map((item: any, index: number) => (
                    <Tag disabled={!item.v} key={`${index}`} margin={'0 10px 10px 0'} callback={onSwapName(item)}>{item.w}</Tag>
                  ))}
                </ContainerBlock>
                <Button label="Confirm" margin="0 0 20px" disabled={familyName.length === 0} onClick={onConfirmSwap} />
                <Button label="Cancel" margin="0" variant="secondary" onClick={toggleSelectFamilyModal} />
              </Modal>
            </form>
          )}
          {step === 2 && (
            <form onSubmit={e => { e.preventDefault() }} noValidate>
              {addressInformation && <Listing sources={addressInformation} variant="dash" margin="0 0 30px" />}
              <Heading variant="label" margin="0 0 15px">Mailing address different from your residential address?</Heading>
              <RadioButtonGroup value={isDifferenceAddress} onChange={toggleSegment} margin={`0 0 15px`}>
                <RadioButton value={1} text="Yes"></RadioButton>
                <RadioButton value={0} text="No"></RadioButton>
              </RadioButtonGroup>
              {isDifferenceAddress === 1 && (
                <React.Fragment>
                  <Segment hasBorderTop={true}>
                    <Heading margin="0 0 15px" variant="label">Postal code</Heading>
                    {!addressErrors?.postcode?.isValid && addressErrors?.postcode?.message && (<Bullet variant="error">{addressErrors?.postcode?.message}</Bullet>)}
                    {!isFindAddressValid && (<Bullet variant="error">We couldn&apos;t retrieve your address using the postal code you entered, so please try again</Bullet>)}
                    <PostcodeWrapper>
                      <Input margin="0 0 15px" invalid={!isEmpty(addressErrors?.postcode?.message) || !isFindAddressValid} type="numeric" maxLength={6} name="postcode" onChange={changeAddressForm} value={addressValues['postcode']} />
                      <Button margin="0 0 30px" disabled={!isEmpty(addressErrors?.postcode?.message) && !addressErrors?.postcode?.isValid} label="Find my address" onClick={onFindPlace} />
                    </PostcodeWrapper>


                    <Heading margin="0 0 15px" variant="label">Block / Street no.</Heading>
                    <Input margin="0 0 30px" disabled={!isFoundAddress} maxLength={30} name="block" onChange={changeAddressForm} value={addressValues['block']} />

                    <Heading margin="0 0 15px" variant="label">Unit (if any)</Heading>
                    <TextCollapsible margin="0 0 10px" labelMore="Know more" labelLess="Know less">
                      <Text> For unit number, please input # followed by numeral digits (e.g. #12-456) </Text>
                      <Text>For P.O. Box, please input numeral digits zero (eg. 0)</Text>
                      <Text margin="0 0 15px">For landed property, please input numeral digits (eg. 00-00)</Text>
                    </TextCollapsible>
                    {isFoundAddress && !addressErrors?.unit.isValid && addressErrors?.unit?.message && <Bullet variant="error">{addressErrors?.unit?.message}</Bullet>}
                    <Input margin="15px 0 30px" invalid={isFoundAddress && !addressErrors?.unit.isValid && !isEmpty(addressErrors?.unit?.message)} placeholder="e.g. #12-456" maxLength={30} disabled={!isFoundAddress} name="unit" onChange={changeAddressForm} value={addressValues['unit']} />

                    <Heading margin="0 0 15px" variant="label">Street name</Heading>
                    <Input margin="0 0 30px" disabled={!isFoundAddress} name="street" type="alphanumeric" maxLength={30} onChange={changeAddressForm} value={addressValues['street']} />

                    <Heading margin="0 0 15px" variant="label">Building name (if any)</Heading>
                    <Input margin={0} disabled={!isFoundAddress} name="building" type="alphanumeric" maxLength={30} onChange={changeAddressForm} value={addressValues['building']} />
                  </Segment>

                  {isFoundAddress && (
                    <ContainerBlock margin="30px 0 40px 0">
                      <Checkbox className={modifyCheckbox} name="updateMailing"  checked={values['updateMailing']} onChange={handleChange}>
                        <Text> I would like to also update this mailing address for all my life and health policy(ies) with Singlife*  </Text>
                      </Checkbox>
                      <Text>* Not applicable to MINDEF &amp; MHA Group Insurance / POGIS</Text>
                    </ContainerBlock>
                  )}

                </React.Fragment>
              )}
              {

                isDifferenceAddress === 0 && (
                  <Segment hasBorderTop={true}>
                    <Checkbox name="updateMailing" checked={values['updateMailing']} onChange={handleChange}>
                      <Text> I would like to also update this mailing address for all my life and health policy(ies) with Singlife*  </Text>
                    </Checkbox>
                    <Text>* Not applicable to MINDEF &amp; MHA Group Insurance / POGIS</Text>
                  </Segment>
                )
              }
              <Button
                onClick={onContinue}
                disabled={isDifferenceAddress === 1 && !addressFormValid}
                label="Continue"
                margin="40px 0 20px 0"
              />
            </form>
          )}
          <Button variant="secondary" label="Back" margin="0 0 40px" onClick={onBack} />
        </LeftGrid>
        <EmptyGrid></EmptyGrid>
        {/* <RightGrid>
          <ContactBox items={contactInformation} />
        </RightGrid> */}
        <Modal show={isShowUOB} onClose={() => { setIsShowUOB(false) }}>
          <Text margin={'0px 0 30px'}>You will be redirected to our appointed intermediary - United Overseas Bank Limited (“UOB”) site to submit the contact me form.</Text>
          <Button margin="0 0 20px" label="Proceed" onClick={gotoUOBContact} />
          <Button variant="secondary" label="Cancel" margin={0} onClick={() => { setIsShowUOB(false) }} />
        </Modal>
      </ContainerGrid>

    </Container>
  );
};

export default MyInfo;
